import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=5d3b2b47&scoped=true"
import script from "./EmployeeCard.vue?vue&type=script&lang=js"
export * from "./EmployeeCard.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCard.vue?vue&type=style&index=0&id=5d3b2b47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b2b47",
  null
  
)

export default component.exports